module.exports = __webpack_public_path__ + "account/assets/down.ecb27c6c.svg";